const trustedCompanies = [
  { name: "adidas", image: "/images/alogo.webp", dark: true },
  { name: "Volvo", image: "/images/volvo.svg", dark: true },
  { name: "Stadt Hamburg", image: "/images/hh.svg" },
  { name: "BASF", image: "https://upload.wikimedia.org/wikipedia/commons/9/9c/BASF-Logo_bw.svg", large: true, dark: true },
  { name: "Siemens", image: "https://upload.wikimedia.org/wikipedia/commons/7/79/Siemens_Healthineers_logo.svg", large: true },
  { name: "Telekom", image: "https://upload.wikimedia.org/wikipedia/commons/d/dd/Deutsche_Telekom_2022.svg" },
  { name: "Otto Group", image: "https://upload.wikimedia.org/wikipedia/commons/1/11/Otto_Group_Logo_2022.svg", large: true, dark: true },
  { name: "Hapag-Lloyd", image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/Hapag-Lloyd.svg", dark: true, large: true },
  { name: "Bayer", image: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Logo_Bayer.svg", dark: true },
];

export default trustedCompanies;
